import { render, staticRenderFns } from "./VendedorCrud.vue?vue&type=template&id=490a6e15&"
import script from "./VendedorCrud.vue?vue&type=script&lang=js&"
export * from "./VendedorCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports